import { fillWithLeadingZeros } from 'common/utils/common';

export const getTeksoOrderNumber = (orderBaseNumber: number, paymentNumber: number) => {
	const teksoOrderNumber = Number(orderBaseNumber) + paymentNumber;
	return fillWithLeadingZeros(teksoOrderNumber.toString(), 9);
};
